package com.example.mystybag.core.logic.base

import com.example.mystybag.core.model.CapitalizeButtons
import com.example.mystybag.core.model.ColoredText
import com.example.mystybag.core.model.LinkModel

open class NavigatorConfig

open class UIBottomSheetConfig

open class BottomSheetChild(
    open val viewModel  : BaseViewModel? = null,
    open val showNotch  : Boolean        = true,
    open val canClose   : Boolean        = true,
    open val onTimeout  : (() -> Unit)?  = null,
    open val removeBottomSheetPadding : Boolean = false,
    open val useWebDialogInsets: Boolean = false
)

open class DialogConfig {
    open val title          : String?               = null
    open val message        : String                = ""
    open val clickableText  : List<LinkModel>?      = null
    open val coloredMessage : List<ColoredText>?    = null
    open val positiveTitle  : String                = ""
    open val negativeTitle  : String?               = null
    open val closable       : Boolean               = true
    open val autoBtnCapital : CapitalizeButtons = CapitalizeButtons()
}

fun bottomSheetChildFactory(config: UIBottomSheetConfig, className: String?): BottomSheetChild =
    throw UnsupportedOperationException("$className: attempt to open not configured Bottom Sheet config: [ $config ]")